import React, { Component } from "react";
import { toast } from "react-toastify";
import configData from "../config.json";
import { Button, Row, Col, Card } from "react-bootstrap";
export default class Mpolicydownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),

      reqencrypted_policy_iduestId: sessionStorage.getItem(
        "encrypted_policy_id"
      ),
      isDownloading: false,
      policyStatus: false,
      downloader: false,
      pdfData: "",
      premium: [],
      download: {},
      dateValues: {},

      proposal_no: sessionStorage.getItem("proposal_no"),
      document_id: sessionStorage.getItem("document_id"),
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.success(msg);
    }
  };
  componentDidMount = () => {
    this.handlePaymenVerify();
  };
  handlePaymenVerify = () => {
    const jsonData = {
      payment_id: sessionStorage.payment_id,
    };
    const jsonData1 = JSON.stringify(jsonData);
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("requestId", sessionStorage.proposalPaymentrequest_Id);
    formData.append("jsonData", JSON.stringify(jsonData1));
    formData.append("integId", 352);
    formData.append("savedata", "yes");
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.success);
          sessionStorage.setItem("verifiyrequestId", data.requestId);
          setTimeout(() => {
            this.handlePaymentResponse();
          }, 20000);
        }
      });
  };
  handlePaymentResponse = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 352);
    formData.append("requestId", sessionStorage.verifiyrequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data;
        if (responseData?.encrypted_policy_id) {
          sessionStorage.setItem(
            "encrypted_policy_id",
            responseData.encrypted_policy_id
          );
          sessionStorage.setItem("policy_id", responseData.policy_id);
          sessionStorage.setItem("policy_no", responseData.policy_no);
        }
      })

  };
  handleDownload = () => {
    this.setState({ isDownloading: true }); // Show wait message

    const jsonData = {
      encrypted_policy_id: sessionStorage.encrypted_policy_id,
    };

    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("jsonData", JSON.stringify(jsonData1));
    formData.append("integId", 367);
    formData.append("savedata", "yes");

    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);

        if (data.status === "success") {
          sessionStorage.setItem("downloadrequestID", data.requestId);

          setTimeout(() => {
            this.handlerequestcall(); // This will eventually download PDF
          }, 20000);
        } else {
          this.setState({ isDownloading: false }); // Stop message if failed
        }
      })
      .catch(() => {
        // this.setState({ isDownloading: false });
        // toast.error("Something went wrong. Try again.");
      });
  };


  handlerequestcall = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 367);
    formData.append("requestId", sessionStorage.downloadrequestID);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data || {};

        if (responseData.req_id) {
          sessionStorage.setItem("req_id", responseData.req_id);
          if (responseData.panrequestID) {
            sessionStorage.setItem("requestId", responseData.panrequestID);
          }
          this.setState({ showVerification: true });
        }
        const pdfUrl = data.data?.policyPdfPath;
        // const pdfUrl = `${configData.api_url}${data.data?.policyPdfPath}`;
        this.setState({ isDownloading: false }); // ✅ Stop the wait message

        if (pdfUrl && pdfUrl.startsWith("http")) {
          fetch(pdfUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = "PolicyDocument.pdf"; // 👈 force file name
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch(() => {
              toast.error("Failed to download PDF.");
            });
        } else {
          toast.warning("Policy PDF not available.");
        }
      })

  };

  downloadPdf = (policyPdf) => {
    // console.log(this.state.pdfData);
    const pdfUrl = configData.api_url + policyPdf;
    // console.log(pdfUrl);
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = this.state.premium.policyNumber + ".pdf"; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  render() {
    return (
      <div className="bgalphacolor">
        <h3 className="logoskybluecolor">Download PDF</h3>

        {/* {this.state.premium.policyStatus === "2" ? ( */}
        <Row className="mt-3">
          <Col>
            <Card>
              <div className="thank-you">
                <h1 className="thank-you-header mt-3">Thank You!</h1>
                <span
                  className="bi bi-hand-thumbs-up-fill"
                  style={{ fontSize: "35px", color: "green" }}
                ></span>
                <br />
                <p className="thank-you-text" id="justified-paragraph ">
                  Email-Id :{sessionStorage.email_id}
                  {/* {`${proposer_salutation}${proposer_fname} ${proposer_mname} ${proposer_lname}`} */}
                </p>
                <p className="thank-you-text" id="justified-paragraph ">
                  Registration Number :{" "}
                  {`${sessionStorage.regno_1}${sessionStorage.regno_2}${sessionStorage.regno_3}${sessionStorage.regno_4}`}
                </p>
                <p className="thank-you-text" id="justified-paragraph ">
                  Proposal Number : {sessionStorage.proposal_no}
                </p>
                <p className="thank-you-text" id="justified-paragraph ">
                  Proposal Id : {sessionStorage.proposal_id}
                </p>
                <p className="thank-you-text" id="justified-paragraph ">
                  {/* Document Id : {sessionStorage.premium.document_id} */}
                </p>

                <div>
                  <p
                    className="thank-you-text"
                    id="justified-paragraph"
                    style={{ textAlign: "revert" }}
                  >
                    Policy number : {this.state.premium.policyNumber}
                  </p>
                  <p className="thank-you-text" id="justified-paragraph ">
                    Your Transaction is successful. Policy details will be sent
                    your email.
                  </p>
                  <p className="thank-you-text" id="justified-paragraph ">
                    We appreciate your business and value you as our customer.
                  </p>

                  <>
                    {" "}
                    <div className="thank-you-text">
                      {this.state.isDownloading && (
                        <p style={{ color: "blue", marginTop: "10px" }}>
                          Please wait, downloading...
                        </p>
                      )}
                      <Button
                        onClick={this.handleDownload}
                        className="policiesthanks btn btn-success"
                      >
                        Download
                      </Button>
                    </div>
                  </>
                </div>

                <div>
                  {" "}
                  <p
                    className="thank-you-text"
                    id="justified-paragraph"
                    style={{ textAlign: "revert" }}
                  >
                    Referral message : You may continue with the proposal and
                    the Policy shall be issued post completion of Tele
                    underwriting process.
                  </p>
                  <p className="thank-you-text" id="justified-paragraph ">
                    Your Transaction is successful. Policy details will be sent
                    your email.
                  </p>
                  <p className="thank-you-text" id="justified-paragraph ">
                    We appreciate your business and value you as our customer.
                  </p>
                </div>
              </div>

              <br />
            </Card>
          </Col>
        </Row>

      </div>
    );
  }
}
